<template>
  <div>
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      @reload="getData()"
    >
      <div slot="header" class="d-flex align-items-center">
        <h6 class="m-0">{{ $l('table_header_product') || '产品明细' }}</h6>
        <el-divider direction="vertical" v-if="!disabled" />
        <b-button
          v-if="!disabled"
          size="sm"
          variant="outline-primary"
          @click="addProductVisible = true"
        >
          {{ $l('btn_addProduct') || '选择报价产品' }}
        </b-button>
      </div>
    </PageMain>

    <AddProduct
      :visible.sync="addProductVisible"
      :quotationCode="quotationCode"
      :custName="custName"
      @reload="getData()"
    />
  </div>
</template>
<script>
import PageMain from './main.vue'
import AddProduct from '../add-product'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { PageMain, AddProduct },
  props: {
    quotationCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    custName: { type: String, default: '' },
  },
  data() {
    return { loading: false, tableData: [], addProductVisible: false }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.quotationCode) return
      this.loading = true
      const res = await this.$api
        .customerQuotationSampleListApi({ quotationCode: this.quotationCode })
        .catch(() => null)
      this.loading = false
      this.tableData = res?.body?.data || []
    },
  },
}
</script>
